import coachImage from "../assets/mainView/Coach.jpeg";
import emuImage from "../assets/mainView/EMU.png";
import icfImage from "../assets/mainView/ICF.png";
import lhbImage from "../assets/mainView/LHB.png";
import locoImage from "../assets/mainView/LOCO.png";
import locoJpegImage from "../assets/mainView/Loco.jpeg";
import wag12Image from "../assets/mainView/WAG12.png";
import wagonImage from "../assets/mainView/Wagon.png";
import metroImage from "../assets/mainView/metro.jpg";
import metroLocoImage from "../assets/mainView/metroloco.jpg";

/**
 * Returns the appropriate image for a coach based on its position, type, label, coach object, and train type.
 * @param {Object|string} coach - The coach object or coach type string
 * @param {string} defaultType - The overall train's type of coaches (e.g. WAGON, LHB, ICF, EMU)
 * @returns {string} Image asset path
 */
export const getCoachImage = (coach, defaultType = "") => {
  if (!coach) return wagonImage || coachImage;

  let searchStr = "";
  if (typeof coach === "string") {
    searchStr = coach;
  } else if (typeof coach === "object") {
    searchStr = [
      coach.type,
      coach.position,
      coach.label,
      coach.coachPosition,
      coach.coachType,
      coach.asset_type,
      coach.transportation_code,
      coach.bogiType,
      coach.coachNumber,
      coach.defaultCoachType,
      coach.trainType,
    ]
      .filter(Boolean)
      .join(" ");
  }

  if (defaultType) {
    searchStr = `${searchStr} ${defaultType}`;
  }

  const str = searchStr.toUpperCase();

  // Determine if this specific coach is a Locomotive
  const isLoco =
    str.includes("LOCO") ||
    str.includes("WAG12") ||
    str.includes("WAG-12") ||
    str.includes("WAP") ||
    str.includes("METROLOCO") ||
    str.includes("ENGINE");

  if (isLoco) {
    if (str.includes("WAG12") || str.includes("WAG-12") || str.includes("WAG 12")) {
      return wag12Image;
    }
    if (
      str.includes("METROLOCO") ||
      (str.includes("METRO") && (str.includes("LOCO") || str.includes("ENG") || str.includes("MOTOR")))
    ) {
      return metroLocoImage;
    }
    return locoImage || locoJpegImage;
  }

  // Non-locomotive coach matching
  if (str.includes("WAG12") || str.includes("WAG-12") || str.includes("WAG 12")) {
    return wag12Image;
  }

  if (
    str.includes("WAGON") ||
    str.includes("BOXN") ||
    str.includes("BOST") ||
    str.includes("BCNA") ||
    str.includes("BCNHL") ||
    str.includes("BOBYN") ||
    str.includes("BTPN") ||
    str.includes("FREIGHT") ||
    str.includes("GOODS")
  ) {
    return wagonImage;
  }

  if (str.includes("ICF")) {
    return icfImage;
  }

  if (str.includes("LHB")) {
    return lhbImage;
  }

  if (str.includes("EMU") || str.includes("MEMU") || str.includes("DEMU")) {
    return emuImage;
  }

  if (str.includes("METRO")) {
    return metroImage;
  }

  // Fallback to standard coach image
  return coachImage;
};

export default getCoachImage;
